import React, { useState } from 'react';
import './faq.css';

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section className="section" id="faq">
      <div className="container faq">
        <h2 style={{ margin: '0 0 18px' }}>FAQ</h2>
        <div className="qa">
          <div className="q" onClick={() => toggle(0)} role="button" aria-expanded={openIndex === 0}>
            <strong>Do I need funds to try it?</strong>
            <span>{openIndex === 0 ? '▴' : '▾'}</span>
          </div>
          <div className={`a ${openIndex === 0 ? 'open' : ''}`}>
            <p>No. The demo mode is free: you get a virtual balance and the full terminal features.</p>
          </div>
        </div>

        <div className="qa">
          <div className="q" onClick={() => toggle(1)} role="button" aria-expanded={openIndex === 1}>
            <strong>What about limits and fees?</strong>
            <span>{openIndex === 1 ? '▴' : '▾'}</span>
          </div>
          <div className={`a ${openIndex === 1 ? 'open' : ''}`}>
            <p>Min order size and conditions depend on the instrument. All fees/spreads are transparent and shown before confirmation.</p>
          </div>
        </div>

        <div className="qa">
          <div className="q" onClick={() => toggle(2)} role="button" aria-expanded={openIndex === 2}>
            <strong>Can I trade on mobile?</strong>
            <span>{openIndex === 2 ? '▴' : '▾'}</span>
          </div>
          <div className={`a ${openIndex === 2 ? 'open' : ''}`}>
            <p>Yes. The UI is responsive for mobile browsers. Native apps are planned.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
